import React from 'react'

import intl from 'react-intl-universal'
import { string, number, arrayOf, bool } from 'prop-types'

import PageBanner from 'components/organisms/PageBanner'
import Typography from 'components/atoms/Typography/Typography'
import { SVGIcon } from 'components/qstrap'

const CareerBriefDetail = ({
  salaryRange,
  minEducation,
  certifications,
}) => (
  <>
    {
      salaryRange &&
      <div className="campus-career-brief-detail__item">
        <SVGIcon name="campus-money" size="md"/>
        <Typography variant="body">{salaryRange}</Typography>
        <span className="tip-info">
          Perkiraan penghasilan untuk level awal. Bervariasi tergantung kebijakan perusahaan dan trend industri
        </span>
      </div>
    }
    {
      minEducation &&
      <div className="campus-career-brief-detail__item">
        <SVGIcon name="campus-education" size="md"/>
        <Typography variant="body">{minEducation}</Typography>
      </div>
    }
    {
      certifications &&
      <div className="campus-career-brief-detail__item">
        <SVGIcon name="common-certificate" size="md"/>
        <Typography variant="body">{ certifications }</Typography>
      </div>
    }
    <style jsx>
      {`
        .campus-career-brief-detail__item {
          width: 100%;
          display: flex;
          align-items: center;
          margin: 16px 0px 0px;
          :global(svg.icon) {
            margin-right: 8px;
            fill: #2440a4;
            min-width: 32px;
          }
          .tip-info {
            display: none;
          }
          :hover {
            .tip-info {
              border-radius: 4px;
              background-color: #0c2846;
              padding: 5px 20px 5px 5px;
              display: block;
              z-index: 100;
              left: 5%;
              margin: 10px;
              max-width: 300px;
              position: absolute;
              text-decoration: none;
              color: #fff;
              font-size: 11px;
              margin-top: 40px;
            }
          }
        }
      `}
    </style>
  </>
)

CareerBriefDetail.propTypes = {
  salaryRange: string,
  minEducation: string,
  certifications: string,
}

const CareerBanner = ({
  name,
  iconName,
  field,
  minSalary,
  maxSalary,
  minEducation,
  certifications,
  imgLink,
  likeStatus,
  likeTarget,
}) => {
  const salaryRange = (min, max) => {
    const formattedMin = intl.get('numbers.salary', { salary: min })
    const formattedMax = intl.get('numbers.salary', { salary: max })

    const minSal = min ? formattedMin.substring(0, formattedMin.length - 3) : ''
    const dash = min && max ? ' - ' : ''
    const maxSal = max ? formattedMax.substring(0, formattedMax.length - 3) : ''
    return `${minSal}${dash}${maxSal}`
  }

  const minEducationTxt = val => val && `${val.toUpperCase()} Sederajat`

  const certificationsTxt = val => val.length > 0 && val.join(', ')

  return (
    <PageBanner
      title={name}
      subtitle={field}
      iconName={iconName}
      iconBg="#2440a4"
      imgSrc={imgLink}
      likeStatus={likeStatus}
      likeTarget={likeTarget}
      kind="professions"
      content={
        <CareerBriefDetail
          salaryRange={salaryRange(minSalary, maxSalary)}
          minEducation={minEducationTxt(minEducation)}
          certifications={certificationsTxt(certifications)}
        />
      }
      forDetailPage
    />
  )
}

CareerBanner.propTypes = {
  name: string,
  iconName: string,
  field: string,
  minSalary: number,
  maxSalary: number,
  minEducation: string,
  certifications: arrayOf(string),
  imgLink: string,
  likeStatus: bool,
  likeTarget: string,
}

export default CareerBanner
